import {
  INICIALITZAR,
  OBTENIR_DADES_CREACIO_INDIVIDU
} from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const varietats = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_SUCCESS`:
      return action.payload.varietats;
    default:
      return state;
  }
};

export default varietats;

const totsVarietats = state => state.varietats;

export const getVarietats = state => {
  const varietats = totsVarietats(state);

  if (!varietats) {
    return null;
  }
  return varietats;
};
